/**
 * Where the catalogue is. `loading` and `failed` only while there is nothing
 * to show yet: a count read off an empty list would say "0", as if Morocco
 * were empty. Once items are in, their counts are real, zero included.
 */
export type CountsState = "ready" | "loading" | "failed";

export function countsState(
  itemCount: number,
  isLoading: boolean,
  error: string | null,
): CountsState {
  if (itemCount > 0) return "ready";
  if (isLoading) return "loading";
  return error ? "failed" : "ready";
}
